// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e299b61","732":"bf71a1ef","977":"487d6aad"}[chunkId] + ".chunk.js";
};